import React from 'react';
//import ReactDOM from 'react-dom/client';
//import { render } from 'react-dom'; 
import { createRoot } from 'react-dom/client';
//import { render } from 'react-dom';
import App from './App';


//const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const rootElement = document.getElementById('wrapper');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement); 
root.render(
   <App />
);